import { useState } from 'react';
import { api } from './api';

interface Props {
  onAuthed: (username: string) => void;
}

type Mode = 'login' | 'signup';

export function AuthScreen({ onAuthed }: Props) {
  const [mode, setMode] = useState<Mode>('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const path = mode === 'login' ? '/api/login' : '/api/signup';
      const res = await api.post<{ ok: true; username: string }>(path, { username, password });
      onAuthed(res.username);
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center">
      <div className="panel auth-card">
        <h2 style={{ marginTop: 0 }}>{mode === 'login' ? 'Sign in' : 'Create account'}</h2>
        <form onSubmit={submit}>
          <div className="field">
            <label>Username</label>
            <input
              autoCapitalize="none" autoCorrect="off" autoComplete="username"
              value={username} onChange={(e) => setUsername(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          <div className="field">
            <label>Password</label>
            <input
              type="password" autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              value={password} onChange={(e) => setPassword(e.target.value)}
              style={{ width: '100%' }}
              required
            />
          </div>
          {err && <div className="field error">{err}</div>}
          <div className="row">
            <button type="submit" disabled={busy}>
              {busy ? '…' : mode === 'login' ? 'Sign in' : 'Create account'}
            </button>
            <button
              type="button" className="secondary"
              onClick={() => { setMode(mode === 'login' ? 'signup' : 'login'); setErr(null); }}
            >
              {mode === 'login' ? 'Need an account?' : 'Have an account?'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
